module.exports = __webpack_public_path__ + "img/horizontal-logo-pink-sg.d9413e53.svg";